import { createContext } from "react";

export const DomainsCloudflareCacheClearContext = createContext(async () => {})